import { TimelineMode } from "@/components/TimelineModePicker/TimelineModePicker.decl";
import { Slice } from "../store.decl";

export type TimelineModeSliceState = {
  mode: TimelineMode | null;
  setMode: (mode: TimelineMode) => void;
};

export const createTimelineModeSlice: Slice<TimelineModeSliceState> = (
  set
) => ({
  mode: "simple",
  setMode: (mode) => set(() => ({ mode })),
});
